const { createSlice } = require("@reduxjs/toolkit");

const bundleDataSlice = createSlice({
  name: "bundleData",
  initialState: {},
  reducers: {
    editBundleData(state: any, action: any) {
      // console.log("STATE FROM REDUX: ", state);
      // console.log("ACTION FROM REDUX: ", action);
      // console.log("EDITED BUNDLE DATA");
      state.bundleData = action.payload;
    },
  },
});

export const bundleActions = bundleDataSlice.actions;

export default bundleDataSlice.reducer;
